import React from 'react'
import TextField from '../../../Components/textField/textField';
import CommonButton from '../../../Components/commonButton/commonButton'
import Api from '../../../services/api'
import Alert from '../../../Components/alert/Alert'
import {Badge} from 'react-bootstrap'
import Slider from '../../../Components/slider/slider'
import Select from "../../../Components/select/select";
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import '../general.css'

export default class addMachine extends React.Component {

  state = {
    description: "", code: null, id_work_shift: [], work_shifts: [], id_department: 0, shifts: [],
    show: false, message: "", oeeGoal: 0, badge_work_shifts: [], showModal: false, departments: [],
    departments_id: [], reload: false, factorys: [], factorysAllProps: [],is_machine:false,
    doubleAlert:false,notification: false, notification_type: 'success', notification_message: ''
  }

  async componentDidMount() {
    let work_shifts = []
    let work_shifts_ids = []
    await Api.get('/work-shifts/').then(resp => {
      resp.data.forEach(element => {
        work_shifts.push({ value: element.code, label: element.code })
        work_shifts_ids.push({ id: element.id, code: element.code })
      });

      this.setState({ shifts: work_shifts, work_shifts: work_shifts_ids })
    }).catch(error => {
      this.setState({ message: 'Erro de conexão com o servidor.', show: true })
    })

    await Api.get('/departments/').then((resp) => {
      this.setState({ departments_id: [...resp.data] })
    })

    await Api.get('/factorys/').then((resp) => {
      let factorys = []
      resp.data.forEach(element => { factorys.push({ value: element.id, label: element.description }) });
      this.setState({ factorys: factorys, factorysAllProps: [...resp.data] })
    })
  }

  callBackDesc = (child) => { this.setState({ description: child }) }
  callBackCode = (child) => { this.setState({ code: child }) }
  callBackDepartment = (child) => {
    const { id } = this.state.departments_id.find((e) => e.id === child)
    this.setState({ id_department: id })

  }
  callBackIdWorkShift = (child) => {
    const { id } = this.state.work_shifts.find((e) => e.code === child)
    this.state.id_work_shift.push(id)
    if (this.state.badge_work_shifts.length === 0)
      this.state.badge_work_shifts.push(child)

    if (this.state.badge_work_shifts.length > 0) {
      let code = this.state.badge_work_shifts.find((e) => e === child)
      if (code === undefined)
        this.state.badge_work_shifts.push(child)
    }
    this.forceUpdate();
  }

  callBackOeeGoal = (child) => { this.setState({ oeeGoal: child }) }
  callbackfunction = () => { this.setState({ show: false }) }

  sendData = async () => {
    let { code, description, id_work_shift, id_department, oeeGoal, id_factory,is_machine,doubleAlert } = this.state

    oeeGoal = parseInt(oeeGoal)
    if ((description !== "" && description !== null) && (code !== null && code !== "") && id_work_shift.length > 0 && oeeGoal > 0) {
      if (oeeGoal > 50) {
        Api.post('/machines/', {
          code: code,
          description: description,
          id_department: id_department,
          oee_goal: oeeGoal,
          id_work_shift: id_work_shift,
          is_machine:is_machine,
          doubleAlert:doubleAlert,
          id_factory: id_factory,
        }).then((resp) => {
          if (resp.status !== 201) {
            return this.setState({ message: "" + resp.data.response, show: true, reload: true })
          }
          this.setState({ id_machine: resp.data.insertId })
          this.setState({notification: true, notification_message: "Máquina cadastrada com sucesso!"});
          setTimeout(()=>{
            return window.location.reload();
          },2000)
        }).catch((error) => {
          this.setState({ message: "Erro de conexão.", show: true })
        })
      } else {
        this.setState({ message: "Defina um valor acima de 50% para a meta de OEE.", show: true })
      }

    } else {
      this.setState({ message: "Necessário preencher todos os campos.", show: true })
    }
  }

  activeMonitoring = () => {
    Api.post(`/track-machines/${this.state.id_machine}`).then(resp => {
      if (resp.data.error !== undefined) {
        this.setState({ showModal: false })
        return this.setState({ message: resp.data.error, show: true, reload: true })
      }
      this.setState({ showModal: false })
      window.location.reload()
    }).catch(error => {
      alert('Erro 1', error)
    })
  }
  setCheckValue = () =>{this.setState({is_machine:!this.state.is_machine})}
  setCheckDoubleAlert = () =>{this.setState({doubleAlert:!this.state.doubleAlert})}

  handleBadge = (e) => {
    let workShift = e.target.title
    const { id } = this.state.work_shifts.find(value => value.code === workShift)
    let result = this.state.id_work_shift.filter(value => value !== id)
    let resultBadge = this.state.badge_work_shifts.filter(value => value !== workShift)
    this.setState({ id_work_shift: result, badge_work_shifts: resultBadge })
  }

  SelectFactory = (childData) => {
    const { id } = this.state.factorysAllProps.find(v => v.id === childData);
    let arrDeparts = [...this.state.departments_id];
    let result = arrDeparts.filter(e => e.id_factory === id);
    let arraDeps = [];
    result.forEach(el => { arraDeps.push({ value: el.id, label: el.description }) })
    this.setState({ departments: arraDeps, id_factory: id });
  }

  render() {
    const { show, message, reload, notification, notification_message, notification_type } = this.state
    return (
      <>
      {notification == true ? (<><Notification message={notification_message} type={notification_type}></Notification><Loading></Loading></>) : (<></>)}
      <div className="box">
        <div className="input_fields_add_machine form">
          <h4>Adicionar Máquina</h4>
          <div className="inputs">
          {show ? <Alert show={show} message={message} parentCallback={this.callbackfunction} reload={reload} /> : null}
          <div className='tf1AddMachine element'><TextField focus={true} title="Descrição da máquina" min={3} max={30} value={this.state.description} validationType="varchar" parentCallback={this.callBackDesc} /></div>
          <div className='tf2AddMachine element'><TextField section={true} title="Código" max={20} value={this.state.code} validationType="varchar" parentCallback={this.callBackCode} /></div>
          <div className="element">
            <div className='select1AddMachine' >
              <Select autoSelect={false} label="Turno" handleSelect={this.callBackIdWorkShift} arrData={this.state.shifts} />
            </div>
            <div className='badgeAddMachine element badge' id='badge2'>
              {this.state.badge_work_shifts.map((item, index) => (
                <div><Badge key={index} title={item} onClick={this.handleBadge} variant="secondary">{item}</Badge></div>))}
            </div>
          </div>
          <div className='select2AddMachine element'  ><Select autoSelect={false} label="Planta" handleSelect={this.SelectFactory} arrData={this.state.factorys} /></div>
          <div className='select3AddMachine element'  ><Select autoSelect={false} label="Setor" handleSelect={this.callBackDepartment} arrData={this.state.departments} /></div>
          <div className='sliderAddMachine element slider'><Slider title={"OEE Meta"} parentCallback={this.callBackOeeGoal}></Slider></div>
          <div className='checkboxs'>
          <div class="form-check element"  >
            <input class="form-check-input" type="checkbox" checked={this.state.is_machine} id="flexCheckDefault" onClick={this.setCheckValue}/>
              <label class="form-check-label" for="flexCheckDefault">
                Apontamento Automático
              </label>
          </div>
          <div class="form-check element"  >
            <input class="form-check-input" type="checkbox" checked={this.state.doubleAlert} 
            id="doubleAlert" onClick={this.setCheckDoubleAlert}/>
              <label class="form-check-label" for="doubleAlert">
                Alerta de dois níveis (andon)
              </label>
          </div>
          </div>
          </div>
          <div  className="submitButton"><CommonButton title="Enviar" parentCallback={this.sendData} /></div>
        </div>
      
      </div>
      </>)
  }
}